import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from "react";

interface ITabsetPreview {
  type: "container";
  container: {
    type: "tabset";
    selectedTabId: string;
  };
}

type TContainerPreview = ITabsetPreview;

type THeadingPreview = {
  type: "element";
  element: {
    type: "heading";
    level: number;
  };
};

type TElementPreview = THeadingPreview;

type TSectionEntityPreview = TContainerPreview | TElementPreview;

interface ISectionEntityPreviewContext {
  preview: TSectionEntityPreview;
  setPreview: Dispatch<SetStateAction<TSectionEntityPreview>>;
}

const defaultSectionEntityPreviewContext: ISectionEntityPreviewContext = {
  preview: null,
  setPreview: null,
};

const SectionEntityPreviewContext = createContext<ISectionEntityPreviewContext>(
  defaultSectionEntityPreviewContext,
);

export const useSectionEntityPreviewContext = () => useContext(SectionEntityPreviewContext);

interface ISectionEntityPreviewProviderProps {
  children: ReactNode;
}

export function SectionEntityPreviewProvider(props: ISectionEntityPreviewProviderProps) {
  const { children } = props;

  const [preview, setPreview] = useState<TSectionEntityPreview>(null);

  const contextValue: ISectionEntityPreviewContext = useMemo(() => ({
    preview,
    setPreview,
  }), [preview]);

  return (
    <SectionEntityPreviewContext.Provider value={contextValue}>
      {children}
    </SectionEntityPreviewContext.Provider>
  );
}
